// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const dashboardApi = baseApi.injectEndpoints({
  // reducerPath: "dashboardApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getDashboardDetails: builder.query({
      query: () => {
        return {
          url: "admin/dashboard",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            // authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["deleteUser", "deletePost"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDashboardDetailsQuery } = dashboardApi;
